//import { Division } from './../../pages/masters/components/sales-terminal/sales-terminal.interface';
// import {
//   AdditionalCostService,
//   prodCost,
// } from './../../pages/Purchases/components/AdditionalCost/addtionalCost.service';
//import { AddUser } from "./../../pages/userManager/components/userManger/adduser.component";
//import { TAcList } from './../interfaces';
import { TransactionService } from './transaction.service';
//import { PREFIX } from "./../interfaces/Prefix.interface";
//import { TrnMainPurchaseComponent } from "./trnmain-purchase.component";
import { MatFormField } from '@angular/material/form-field';
import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnDestroy,
  ViewChild,
} from '@angular/core';

import { Router, ActivatedRoute } from '@angular/router';
//import { Item } from './../interfaces/ProductItem';
//import {TAcList} from '../../../../common/interfaces';
import {
  TrnMain,
  TrnProd,
  CostCenter,
  VoucherTypeEnum,
} from './../interfaces/TrnMain';
//import { ProductInsertComponent } from './ProductInsert';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { MasterRepo } from './../repositories/masterRepo.service';
import { Warehouse } from './../interfaces';
//import { AppSettings } from './../AppSettings';
//import { Observable } from "rxjs/Observable";
//import { Subscriber } from "rxjs/Subscriber";
import { Subscription } from 'rxjs';
import { SettingService } from './../services';

@Component({
  selector: 'voucher-date-entry',
  templateUrl: './voucher-date.component.html',
  styleUrls: ['../../pages/Style.css', './_theming.scss'],
})
export class VoucherDateComponent implements OnDestroy {
  @Input() isSales: any;
  transactionType!: string; //for salesmode-entry options
  mode: string = 'NEW';
  modeTitle: string = '';
  //private returnUrl: string;
  TrnMainObj: TrnMain = <TrnMain>{};
  divisionList: any[] = [];
  TrnDate!: Date;
  Trn_Date!: Date;
  warehouse: string = '';
  // private vchrno: string;
  // private division: string;
  // private phiscalid: string;
  form!: FormGroup;
  AppSettings: any;
  pageHeading!: string;
  showOrder = false;
  voucherType: VoucherTypeEnum = VoucherTypeEnum.Default;
  subscriptions: any[] = [];
  tempWarehouse: any;
  // additonalCost is 99 sends from AdditionalCost component
  @Input() additionCost: number = 0;
  @Output() additionalcostEmit = new EventEmitter();

  constructor(
    public masterService: MasterRepo,
    public _trnMainService: TransactionService,
    private _fb: FormBuilder,
    private router: Router,
    private arouter: ActivatedRoute,
    private setting: SettingService //public additionalCostService: AdditionalCostService
  ) {
    // this.TrnMainObj = _trnMainService.TrnMainObj;
    // this.AppSettings = this.setting.appSetting;
    // this.voucherType = this.TrnMainObj.VoucherType;
    // this.masterService.refreshTransactionList();
    // if (this.TrnMainObj.VoucherType == VoucherTypeEnum.CreditNote || this.TrnMainObj.VoucherType == VoucherTypeEnum.SalesReturn) {
    //     this.transactionType = 'creditnote';
    // }
  }

  ngOnInit() {}

  private setDivision(division: string): void {
    if (division == '') division = this.AppSettings.DefaultDivision;
    this.divisionList = [];
    let defaultDiv;
    var sub = this.masterService.divisionList$.subscribe(
      (data: any) => {
        this.divisionList = data;
        defaultDiv = this.divisionList.filter(
          (d) => d.INITIAL == this.AppSettings.DefaultDivision
        )[0];
        console.log({
          completeDivisionList: this.divisionList,
          filteredDiv: defaultDiv,
        });
        if (defaultDiv) {
          this.form?.get('DIVISION')?.setValue(defaultDiv);
        }
      },
      (error: any) => {
        console.log({ divisionloadError: error });
        this.masterService.resolveError(error, 'voucher-date - setDivision');
      }
    );
    this.subscriptions.push(sub);
  }
  // private resolevError(error: Error) {
  //     if (error.message == 'The ConnectionString property has not been initialized.') {
  //         // this.router.navigate(["/login", { returnUrl: this.router.url }]);
  //     }
  //     else {
  //         alert(error.message);
  //     }
  // }

  displayFn(division: any): string {
    return division ? division.NAME : division;
  }

  changeTrnDate(value: any, format: string) {
    try {
      var adbs = require('ad-bs-converter');
      if (format == 'AD') {
        var adDate = value.replace('-', '/').replace('-', '/');
        var bsDate = adbs.ad2bs(adDate);
        this.form
          ?.get('BS_DATE')
          ?.setValue(
            bsDate.en.year +
              '-' +
              (bsDate.en.month == '1' ||
              bsDate.en.month == '2' ||
              bsDate.en.month == '3' ||
              bsDate.en.month == '4' ||
              bsDate.en.month == '5' ||
              bsDate.en.month == '6' ||
              bsDate.en.month == '7' ||
              bsDate.en.month == '8' ||
              bsDate.en.month == '9'
                ? '0' + bsDate.en.month
                : bsDate.en.month) +
              '-' +
              (bsDate.en.day == '1' ||
              bsDate.en.day == '2' ||
              bsDate.en.day == '3' ||
              bsDate.en.day == '4' ||
              bsDate.en.day == '5' ||
              bsDate.en.day == '6' ||
              bsDate.en.day == '7' ||
              bsDate.en.day == '8' ||
              bsDate.en.day == '9'
                ? '0' + bsDate.en.day
                : bsDate.en.day)
          );
      } else if (format == 'BS') {
        var bsDate = value.replace('-', '/').replace('-', '/');
        var adDate = adbs.bs2ad(bsDate);
        this.form
          ?.get('TRN_DATE')
          ?.setValue(
            adDate.year +
              '-' +
              (adDate.month.toString().length == 1
                ? '0' + adDate.month
                : adDate.month) +
              '-' +
              (adDate.day.toString().length == 1
                ? '0' + adDate.day
                : adDate.day)
          );
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  clickTrnDate(value: any) {
    try {
      if (value != null && value != 0) {
        var adbs = require('ad-bs-converter');
        var bsDate = value.replace('-', '/').replace('-', '/');
        var adDate = adbs.bs2ad(bsDate);
        this.form
          ?.get('TRN_DATE')
          ?.setValue(
            adDate.year +
              '-' +
              (adDate.month.toString().length == 1
                ? '0' + adDate.month
                : adDate.month) +
              '-' +
              (adDate.day.toString().length == 1
                ? '0' + adDate.day
                : adDate.day)
          );
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  changeEntryDate(value: any, format: string) {
    try {
      var adbs = require('ad-bs-converter');
      if (format == 'AD') {
        var adDate = value.replace('-', '/').replace('-', '/');
        var bsDate = adbs.ad2bs(adDate);
        this.form
          ?.get('BSDATE')
          ?.setValue(
            bsDate.en.year +
              '-' +
              (bsDate.en.month == '1' ||
              bsDate.en.month == '2' ||
              bsDate.en.month == '3' ||
              bsDate.en.month == '4' ||
              bsDate.en.month == '5' ||
              bsDate.en.month == '6' ||
              bsDate.en.month == '7' ||
              bsDate.en.month == '8' ||
              bsDate.en.month == '9'
                ? '0' + bsDate.en.month
                : bsDate.en.month) +
              '-' +
              (bsDate.en.day == '1' ||
              bsDate.en.day == '2' ||
              bsDate.en.day == '3' ||
              bsDate.en.day == '4' ||
              bsDate.en.day == '5' ||
              bsDate.en.day == '6' ||
              bsDate.en.day == '7' ||
              bsDate.en.day == '8' ||
              bsDate.en.day == '9'
                ? '0' + bsDate.en.day
                : bsDate.en.day)
          );
      } else if (format == 'BS') {
        var bsDate = value.replace('-', '/').replace('-', '/');
        var adDate = adbs.bs2ad(bsDate);
        this.form
          ?.get('TRNDATE')
          ?.setValue(
            adDate.year +
              '-' +
              (adDate.month.toString().length == 1
                ? '0' + adDate.month
                : adDate.month) +
              '-' +
              (adDate.day.toString().length == 1
                ? '0' + adDate.day
                : adDate.day)
          );
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }

  clickEntryDate(value: any) {
    try {
      if (value != null && value != 0) {
        var adbs = require('ad-bs-converter');
        var bsDate = value.replace('-', '/').replace('-', '/');
        var adDate = adbs.bs2ad(bsDate);
        this.form
          ?.get('TRNDATE')
          ?.setValue(
            adDate.year +
              '-' +
              (adDate.month.toString().length == 1
                ? '0' + adDate.month
                : adDate.month) +
              '-' +
              (adDate.day.toString().length == 1
                ? '0' + adDate.day
                : adDate.day)
          );
      }
    } catch (ex) {
      console.log(ex);
      alert(ex);
    }
  }
  ngOnDestroy() {
    try {
      this.subscriptions.forEach((sub: Subscription) => {
        sub.unsubscribe();
      });
    } catch (ex) {
      console.log({ OnDestroyVoucherDate: ex });
    }
  }
  ReferenceLoad() {
    let vchrno = this.form?.get('REFBILL')?.value;
    if (!vchrno) {
      return;
    }
    console.log({ ondispathdialogclick: vchrno });
    this.ProdListFillerFromDispatch({
      VCHRNO: vchrno,
      DIVISION: this.AppSettings.DefaultDivision,
      PHISCALID: null,
    });
    return;
  }
  TrnProdObj!: TrnProd;
  ProdListFillerFromDispatch(selectedRow: any) {
    this.TrnMainObj.ProdList = [];
    let response: Array<any> = [];
    this.masterService
      .getList(
        {
          VCHRNO: selectedRow.VCHRNO,
          DIVISION: selectedRow.DIVISION,
          PHISCALID: selectedRow.PhiscalID,
        },
        '/getTrnMain'
      )
      .subscribe(
        (res: any) => {
          console.log({ mainReturn: res });
          var retmain: TrnMain = res.result;
          this.TrnMainObj.TRNMODE = retmain.TRNMODE;
          this.TrnMainObj.TRNAC = retmain.TRNAC;
          this.TrnMainObj.REMARKS = retmain.REMARKS;
          this.TrnMainObj.BILLTO = retmain.BILLTO;
          this.TrnMainObj.BILLTOADD = retmain.BILLTOADD;
          this.TrnMainObj.BILLTOTEL = retmain.BILLTOTEL;
          this.TrnMainObj.BILLTOMOB = retmain.BILLTOMOB;
        },
        (error: any) =>
          this.masterService.resolveError(
            error,
            'trnmain-not-item-prodlistfiller'
          )
      );

    this.masterService
      .getList(
        {
          VCHRNO: selectedRow.VCHRNO,
          DIVISION: selectedRow.DIVISION,
          PHISCALID: selectedRow.PhiscalID,
        },
        '/getDeliveryProdList'
      )
      .subscribe((res: any) => {
        console.log({ getDeliveryProdList: res });
        response = res.result;
        this._trnMainService.cnReturnedProdList = res.result;
        if (response && response.length > 0) {
          for (let p of response) {
            this.TrnMainObj.WAREHOUSE = p.WAREHOUSE;
            this._trnMainService.Warehouse = p.WAREHOUSE;
            this.tempWarehouse = p.WAREHOUSE;
            this.TrnProdObj = p;
            console.log({ p: p });
            this.TrnProdObj = this._trnMainService.CalculateNormal(
              this.TrnProdObj,
              this.AppSettings.ServiceTaxRate,
              this.AppSettings.VATRate
            );
            this.TrnProdObj.REALQTY_IN = p.RealQty;
            this.TrnProdObj.ALTQTY_IN = p.AltQty;
            this.TrnProdObj.RealQty = 0;
            this.TrnProdObj.AltQty = 0;

            this.TrnMainObj.ProdList.push(this.TrnProdObj);
          }
        }
        console.log('prodlist1', this.TrnMainObj.ProdList);
      });
  }
  getAdditionalCost(value: string) {
    // this.additionalCostService.getDivision=this.form.value.DIVISION
    // this.additionalcostEmit.emit(value);
  }
}
